import script from "./Evidence.vue?vue&type=script&setup=true&lang=js"
export * from "./Evidence.vue?vue&type=script&setup=true&lang=js"

import "./Evidence.vue?vue&type=style&index=0&id=090f74fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090f74fb"]])

export default __exports__